import {toast} from "react-toastify";

toast.configure();

const STATUS_CODE_ERROR = /^(Error: )?Request failed with status code \d+$/i;

function resolveFailMessage(props) {
    const fallback = 'Something went wrong. Please try again later.';
    if (props == null || props === '') {
        return fallback;
    }
    if (typeof props === 'string') {
        return STATUS_CODE_ERROR.test(props) ? fallback : props;
    }

    const data = props?.response?.data;
    if (data) {
        const fieldErrors = data.errors
            ? Object.values(data.errors).flat().filter((message) => typeof message === 'string' && message.trim() !== '')
            : [];
        if (fieldErrors.length > 0) {
            return fieldErrors.join(' ');
        }
        if (typeof data.message === 'string' && data.message.trim() !== '') {
            return data.message;
        }
    }

    if (typeof props.message === 'string' && props.message.trim() !== '' && !STATUS_CODE_ERROR.test(props.message)) {
        return props.message;
    }

    return fallback;
}

const failAlert = (props) =>
    toast.error(resolveFailMessage(props), {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
});
export default failAlert
